/* eslint-disable no-nested-ternary */
import React from "react";
import Image from "@Components/Image";
import LottieAnimator from "@Components/LottieAnimator";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import styles from "./amberSalesBanner.module.scss";

interface AmberSalesBannerProps {
  src: string;
  id: string;
  width?: string | number;
  height?: string | number;
  className?: string;
  alt?: string;
  isEagerLoad?: boolean;
  isMapView?: boolean;
}

/**
 * Renders a sale/fest banner — uses LottieAnimator if the src ends with .json,
 * otherwise falls back to a static Image.
 * Wraps content in a sized container to prevent CLS during hydration.
 */
const AmberSalesBanner: React.FC<AmberSalesBannerProps> = ({
  src,
  id,
  width = "100%",
  height = "auto",
  className,
  alt = "amber-sale-banner",
  isEagerLoad = false,
  isMapView = false,
}) => {
  if (!src) return null;
  const isLottie = src.endsWith(".json");

  const resolvedWidth = typeof width === "number" ? `${width}px` : width;
  const resolvedHeight = typeof height === "number" ? `${height}px` : height;

  const containerStyle: React.CSSProperties = {
    width: resolvedWidth,
    height: resolvedHeight,
  };

  if (isLottie) {
    return (
      <div
        className={formatClassNames(styles.container, className, isMapView && styles.mapViewStyles)}
        style={containerStyle}
      >
        <LottieAnimator
          animationData={src}
          renderer="svg"
          id={id}
          width={resolvedWidth}
          height={resolvedHeight}
        />
      </div>
    );
  }

  return (
    <div className={formatClassNames(styles.container, className)} style={containerStyle}>
      <Image src={src} alt={alt} width={width} height={height} isEagerLoad={isEagerLoad} />
    </div>
  );
};

export default wrapperHOC(AmberSalesBanner, {
  componentName: "AmberSalesBanner",
  showForChina: true,
});
